
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface DocCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  href: string;
  className?: string;
  isInternalLink?: boolean;
  onClick?: () => void;
}

const DocCard = ({ title, description, icon, href, className, isInternalLink = false, onClick }: DocCardProps) => {
  const CardContent = () => (
    <>
      <div className="h-10 w-10 mb-4 bg-recallio-medium-gray rounded-md flex items-center justify-center shrink-0">
        {icon}
      </div>
      
      <h3 className="font-medium mb-2 group-hover:text-recallio-yellow transition-colors truncate w-full">
        {title}
      </h3>
      
      <p className="text-sm text-muted-foreground mb-4 w-full line-clamp-3">
        {description}
      </p>
      
      <div className="flex items-center text-sm text-recallio-yellow group-hover:translate-x-0.5 transition-transform mt-auto">
        Learn more
        <ArrowRight size={14} className="ml-1" />
      </div>
    </>
  );

  const cardClasses = cn(
    "flex flex-col p-5 bg-recallio-dark-gray rounded-lg border border-recallio-light-gray/50 card-glow group h-full cursor-pointer",
    className
  );

  if (onClick) {
    return (
      <div onClick={onClick} className={cardClasses}>
        <CardContent />
      </div>
    );
  }

  if (isInternalLink) {
    return (
      <Link to={href} className={cardClasses}>
        <CardContent />
      </Link>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cardClasses}
    >
      <CardContent />
    </a>
  );
};

export default DocCard;
